import type { ServiceType } from '@prisma-clinic/client'
import { useTranslation } from 'react-i18next'

export const WebinarBadge = ({
    type,
    className = '',
}: {
    type: ServiceType | undefined
    className?: string
}) => {
    const { t } = useTranslation()

    if (type !== 'WEBINAR') return null

    return (
        <span
            className={`rounded-full bg-primary px-3 py-1.5 text-[11px] font-bold uppercase tracking-wider text-white shadow-sm ${className}`}
        >
            {t('frontend.events.webinarBadge')}
        </span>
    )
}
